import * as React from 'react';
import { StyledLayoutContainer, StyledContentContainer, StyledImageContainer } from './styles/LayoutStyles';
var Layout = function (_a) {
    var children = _a.children, imageUrl = _a.imageUrl, className = _a.className, _b = _a.testId, testId = _b === void 0 ? 'kvika-layout' : _b, image = _a.image;
    return (React.createElement(StyledLayoutContainer, { "data-testid": testId, className: className },
        React.createElement(StyledContentContainer, { "data-testid": "".concat(testId, "-content-container") }, children),
        image ? (React.createElement(StyledImageContainer, { "data-testid": "".concat(testId, "-image-container") }, image)) : (React.createElement(StyledImageContainer, { "data-testid": "".concat(testId, "-image-container"), imageUrl: imageUrl }))));
};
export default Layout;
//# sourceMappingURL=Layout.js.map